/**
 * Tutor contract form section.
 * Contract file upload and signature date.
 */
import * as React from 'react';
import { FileSignature } from 'lucide-react';
import { DatePicker } from '@/components/forms/DatePicker';
import { FileDropzone } from '@/components/common/FileDropzone';
import { TUTOR_CONTRACT_UPLOAD_CONFIG } from '@/components/tutors/tutor-configs';
import { defaultUpload, buildContractPatch } from '@/components/tutors/remote/tutor-form-utils';

/** Props for {@link TutorContractSection}. */
type Props = Readonly<{
  formData: Record<string, any>;
  onChange: (key: string, value: any) => void;
  onBatchChange?: (patch: Record<string, any>) => void;
  onFileSelect?: (key: string, file: File | null) => void;
}>;

/** Tutor contract form section. */
export function TutorContractSection({ formData, onChange, onBatchChange, onFileSelect }: Props) {
  return (
    <div className="form-section">
      <h4 className="form-section-title">
        <FileSignature className="w-4 h-4" />
        Contrat
      </h4>
      <div className="space-y-4">
        <FileDropzone
          label="Document de contrat"
          required
          value={formData.contractDocumentLink ?? ''}
          onChange={(url) =>
            onBatchChange
              ? onBatchChange(buildContractPatch(url))
              : onChange('contractDocumentLink', url)
          }
          onFileSelect={onFileSelect ? (file) => onFileSelect('contractFile', file) : undefined}
          uploadFn={onFileSelect ? undefined : defaultUpload}
          accept={TUTOR_CONTRACT_UPLOAD_CONFIG.accept}
          maxSize={TUTOR_CONTRACT_UPLOAD_CONFIG.maxSize}
        />
        <DatePicker
          label="Date de signature"
          value={formData.signedDate ?? ''}
          onChange={(value) => onChange('signedDate', value)}
          inputSize="sm"
          placeholder="JJ/MM/AAAA"
        />
      </div>
    </div>
  );
}
